const INITIAL_STATE = {};

export default function orderDetails(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'orderDetails') {
        return {
          ...state,
          ...payload.response.data,
        };
      }

      return state;
    }

    default:
      return state;
  }
}
